//global
import {RouterStore} from 'mobx-router';
import AuthStore from 'stores/global/auth-store';
import AppStore from 'stores/global/app-store';
import PlatformStore from 'stores/global/platform-store';
import FeedbackStore from 'stores/global/feedback-store';
import NotificationStore from 'stores/global/notification-store';

//shared
import CampaignStore from '@swipe-guide/clients-shared/stores/campaign';
import AnalyticsStore from '@swipe-guide/clients-shared/stores/analytics';
import UiStore from '@swipe-guide/clients-shared/stores/ui';
import ChecklistStore from '@swipe-guide/clients-shared/stores/checklist-store';
import FeedbackDialog from '@swipe-guide/clients-shared/stores/dialogs/feedback-dialog';
import ToastNotificationsStore from '@swipe-guide/clients-shared/stores/toast-notifications';
import CookiePreferenceStore from '@swipe-guide/clients-shared/stores/cookie-preference';
import ForgotWorkspacePasswordDialogStore from '@swipe-guide/clients-shared/stores/forgot-workspace-password-dialog';
import AuthLoginStore from '@swipe-guide/clients-shared/stores/auth-login-store';
import ResetPasswordPage from '@swipe-guide/clients-shared/stores/reset-password-page';
import ReportIssueStore from '@swipe-guide/clients-shared/stores/report-issue-store';
import DispatchStore from '@swipe-guide/clients-shared/stores/dispatch-store';

//pages
import ExplorerPage from 'stores/pages/explorer-page';
import GuidePage from 'stores/pages/guide-page';
import InstructionPage from 'stores/pages/instruction-page';
import ChangePasswordPage from '@swipe-guide/clients-shared/stores/change-password-page';

import {client} from 'utils/apollo-client';

const analytics = new AnalyticsStore();

const store = {
  //global
  auth: new AuthStore(),
  app: new AppStore(),
  platform: new PlatformStore(),
  feedback: new FeedbackStore(),
  notification: new NotificationStore(),
  toastNotifications: new ToastNotificationsStore(),

  //shared
  campaign: new CampaignStore(),
  analytics,
  ui: new UiStore(),
  checklist: new ChecklistStore(client),
  feedbackDialog: new FeedbackDialog(),
  cookiePreference: new CookiePreferenceStore({
    appName: 'VIEWER_DESKTOP',
    enablePosthog: analytics.enablePosthog,
    disablePosthog: analytics.disablePosthog
  }),
  forgotWorkspacePasswordDialog: new ForgotWorkspacePasswordDialogStore(),
  authLogin: new AuthLoginStore(),
  reportIssue: new ReportIssueStore(),
  dispatch: new DispatchStore(),

  //pages
  explorerPage: new ExplorerPage(),
  guidePage: new GuidePage(),
  instructionPage: new InstructionPage(),
  changePasswordPage: new ChangePasswordPage(),
  resetPasswordPage: new ResetPasswordPage()
};

store.router = new RouterStore(store);
store.analytics.setStore(store);
store.ui.setStore(store);
store.campaign.setStore(store);
store.checklist.setStore(store);
store.feedbackDialog.setStore(store);
store.platform.setStore(store);
store.cookiePreference.setNotification(store.notification);
store.changePasswordPage.setNotification(store.notification);
store.forgotWorkspacePasswordDialog.setStore(store);
store.reportIssue.setStore(store);
store.reportIssue.setNotification(store.notification);
store.auth.setNotification(store.notification);
store.resetPasswordPage.setStore(store);
store.resetPasswordPage.setNotification(store.notification);
store.checklist.setNotification(store.notification);
store.dispatch.setStores({
  instructionPage: store.instructionPage,
  checklist: store.checklist
});

export default store;
